import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types';
import { UserProfileModel } from 'client/data/models/profile/profile';
import { bindToPath, connectToModel } from 'client/data/luckdragon/redux/react-binding';

import './insider-page-title-heading-component.scss';

const DASHBOARD_HEADER = 'Insider Dashboard';
const DASHBOARD_STYLES = {
  'size-48': {
    fontSize: '48px',
    lineHeight: '56px',
  },
};

export function InsiderPageTitleHeadingComponentUI({ profileData = null }) {
  const firstName = profileData?.person?.firstName;
  useEffect(() => {
    document.body.classList.add('insider-gradient-header-bg');

    return () => {
      document.body.classList.remove('insider-gradient-header-bg');
    };
  });

  return (
    <Fragment>
      {firstName && (
        <Fragment>
          <div className="hidden-md-down size-24 mb-1 mt-2">Welcome Back, {firstName}!</div>
          <div className="hidden-md-up size-16 mb-0_5 mt-2">Welcome Back, {firstName}!</div>
        </Fragment>
      )}

      <h1 className="insider-page-header text-cool-gray-30 fw-bold  me-md-1_5 mb-1_5 mb-md-1">
        <div className="hidden-md-down d-flex align-items-center">
          <i className="icon-edmunds-car me-0_5 me-md-1 text-primary" aria-hidden style={{ fontSize: '4rem' }} />
          <span style={DASHBOARD_STYLES['size-48']}>{DASHBOARD_HEADER}</span>
        </div>
        <div className="hidden-md-up size-30 d-flex align-items-center">
          <i className="icon-edmunds-car me-0_5 size-36 me-md-1 text-primary" aria-hidden />
          <span className="size-30">{DASHBOARD_HEADER}</span>
        </div>
      </h1>
    </Fragment>
  );
}

InsiderPageTitleHeadingComponentUI.propTypes = {
  profileData: PropTypes.shape({}),
};

const stateToPropsConfig = {
  profileData: bindToPath('data.idm', UserProfileModel),
};

export const InsiderPageTitleHeadingComponent = connectToModel(InsiderPageTitleHeadingComponentUI, stateToPropsConfig);
